import { defineElement, FC, onDidLoad, useProp } from '@atomify/hooks';
import { Fragment, h } from '@atomify/jsx';
import { userStore, wishlistLength as getWishlistLength } from '@store/user';
import { useTranslate } from '@utilities/hooks';

const WishlistHeader: FC = () => {
    const [wishlistLength, seWishlistLength] = useProp('wishlistLength', 0);

    onDidLoad(subscribe);

    function subscribe() {
        userStore.subscribe(() => {
            seWishlistLength(getWishlistLength());
        }, ['wishlist']);
    }

    const theseTranslation = useTranslate('Wishlist-These');
    const housesAreSavedTranslation = useTranslate('Wishlist-HousesAreSaved');
    const wishlistIsEmptyTranslation = useTranslate('Wishlist-WishlistIsEmpty');
    const myWishlistTranslation = useTranslate('Wishlist-MyWishlist');

    return (
        <div class="c-wishlist-header">
            <h1 class="u-h3 u-h1--md">{myWishlistTranslation}</h1>
            <span class="wishlist-header__wishlist-text u-body-normal u-subtitle-1--md">
                {wishlistLength ? (
                    <Fragment>
                        {theseTranslation} {wishlistLength} {housesAreSavedTranslation}
                    </Fragment>
                ) : (
                    <Fragment>{wishlistIsEmptyTranslation}</Fragment>
                )}
            </span>
        </div>
    );
};

WishlistHeader.props = {
    wishlistLength: { type: Number },
};

defineElement('bpd-wishlist-header', WishlistHeader);
